import { observer } from 'mobx-react-lite'
import { ContainerHeader, Typography, variantActionsProps } from 'shared/ui'
import { Breadcrumbs } from 'shared/ui/Breadcrumbs'
import { ReviewsPath } from 'pages/reviews'
import { useReviewAnalyticsContext, useReviewsPageContext } from 'pages/reviews/context'
import { RatingStars } from 'pages/reviews/pages/all/ui/RatingStars/RatingStars'
import styles from './styles.module.scss'

export const ReviewAnalyticsHeader = observer(() => {
  const { name, rating, actions } = useReviewAnalyticsContext()
  const { pageLayoutStore } = useReviewsPageContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore

  return (
    <div className={styles.wrap}>
      <Breadcrumbs customPath={`/${ReviewsPath.root}`} />
      <ContainerHeader
        height={72}
        title={name}
        titleVariant={'heading-lg'}
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        paddingTop={6}
        paddingLeft={20}
        paddingRight={20}
        actionsProps={{
          actions,
          ...variantActionsProps.headerMedium,
        }}
        ellipsis
      />
      <div className={styles.starsWrap}>
        <RatingStars rating={rating} size={16} />
        {!!rating && (
          <Typography variant={'body-lg-medium'} ariaLabel={'ReviewAnalyticsRating'}>
            {rating}
          </Typography>
        )}
      </div>
    </div>
  )
})
